import {
  Settings,
  Sliders,
  Users,
  DollarSign,
  Grid,
  Target,
  FileText,
  PieChart,
  TrendingUp,
  Briefcase,
  Activity,
  Package,
  Bell,
  ShoppingBag,
  UserCheck,
  Layers,
} from 'react-feather';

/**
 * Sprint 2 admin sidebar.
 *
 * Three sections per the Mina Sidor spec:
 *   1. CRM - Försäljning
 *   2. Leverans
 *   3. Drift & administration
 *
 * Items wired to existing legacy pages use `legacyHref`. Items not yet built
 * point to a /admin/.../coming-soon route that renders <ComingSoonPage/>.
 */

const dashboardSection = {
  title: '',
  pages: [
    {
      href: '/admin/dashboard/default',
      title: 'Dashboard',
      icon: Sliders,
    },
  ],
};

const crmSection = {
  title: 'CRM - Försäljning',
  pages: [
    {
      href: '/admin/crm/saljardashboard',
      title: 'Säljardashboard',
      icon: PieChart,
    },
    {
      href: '/admin/crm/pipeline',
      title: 'Pipeline',
      icon: TrendingUp,
    },
    {
      href: '/admin/crm/abonnemang',
      title: 'Abonnemang',
      icon: ShoppingBag,
      children: [
        { href: '/admin/crm/abonnemang', title: 'Alla abonnemang' },
        { href: '/admin/crm/abonnemang/faktureringsbeslut', title: 'Faktureringsbeslut' },
      ],
    },
    {
      href: '/admin/leverans/fakturor',
      title: 'Fakturor',
      icon: DollarSign,
    },
    {
      href: '/admin/proposal',
      title: 'Proposals',
      icon: FileText,
    },
    {
      href: '/admin/crm/arr',
      title: 'ARR & budget',
      icon: TrendingUp,
    },
    {
      href: '/admin/crm/retention',
      title: 'Retention',
      icon: Activity,
    },
    {
      href: '/admin/crm/aktivitet',
      title: 'Aktivitetsöversikt',
      icon: Activity,
    },
    {
      href: '/admin/crm/budgetar',
      title: 'Budgetar',
      icon: TrendingUp,
    },
  ],
};

const leveransSection = {
  title: 'Leverans',
  pages: [
    {
      href: '/admin/leverans/kundlista',
      title: 'Kundlista',
      icon: Users,
    },
    {
      href: '/admin/kundföretag',
      title: 'Kundföretag',
      icon: Users,
    },
    {
      href: '/admin/leads',
      title: 'Kundförfrågningar',
      icon: Target,
    },
    {
      href: '/admin/leverans/bolags-kpi',
      title: 'Bolagsöversikt',
      icon: Briefcase,
    },
    {
      href: '/admin/leverans/produktion',
      title: 'Produktionsvy',
      icon: Package,
    },
    {
      href: '/admin/leverans/forsaljningsanalys',
      title: 'Försäljningsanalys',
      icon: PieChart,
    },
    {
      href: '/admin/leverans/mrr-analys',
      title: 'MRR-analys',
      icon: TrendingUp,
    },
  ],
};

const driftSection = {
  title: 'Drift & administration',
  pages: [
    {
      href: '/admin/drift/anvandare',
      title: 'Användare och roller',
      icon: UserCheck,
    },
    {
      href: '/admin/client',
      title: 'Inlogg kunder',
      icon: Users,
    },
    {
      href: '/admin/drift/produkter',
      title: 'Produktregister',
      icon: Layers,
    },
    {
      href: '/admin/sites',
      title: 'Landningssidor & hemsidor',
      icon: Grid,
    },
    {
      href: '/admin/drift/utm',
      title: 'UTM-spårning',
      icon: Target,
    },
    {
      href: '/admin/drift/fortnox-status',
      title: 'Fortnox-status',
      icon: Activity,
    },
    {
      href: '/admin/drift/svea-status',
      title: 'Svea-status',
      icon: Activity,
    },
    {
      href: '/admin/drift/notifikationer',
      title: 'Notifikationsinställningar',
      icon: Bell,
    },
  ],
};

const legacyAdminSection = {
  title: 'Legacy',
  pages: [
    {
      href: '/admin/users',
      title: 'Användare (legacy)',
      icon: Users,
    },
    {
      href: '/admin/our-leads',
      title: 'Våra leads',
      icon: Target,
    },
    {
      href: '/admin/dpa',
      title: 'DPA Avtal',
      icon: FileText,
    },
    {
      href: '/admin/optimering',
      title: 'Optimering',
      icon: Activity,
      children: [
        { href: '/admin/optimering/all', title: 'Pending' },
        { href: '/admin/optimering/beställning', title: 'Beställning' },
        { href: '/admin/optimering/production', title: 'Production' },
        { href: '/admin/optimering/live', title: 'Live' },
        { href: '/admin/optimering/lost', title: 'Lost' },
      ],
    },
    {
      href: '/admin/data-management',
      title: 'Data Hantering',
      icon: Settings,
      children: [
        { href: '/admin/data-management/cities', title: 'Städer' },
        { href: '/admin/data-management/blocklist', title: 'Blocklista' },
      ],
    },
  ],
};

const navItems = [dashboardSection, crmSection, leveransSection, driftSection, legacyAdminSection];

export default navItems;
